var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v_logged_in",staticStyle:{"padding-top":"60px","text-align":"center","height":"1000px"}},[_c('h1',[_vm._v("Welcome!")])])}]

export { render, staticRenderFns }